import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_square'
})


//Découvrir la notation sous forme de puissance - Réviser certains carrés par cœur.

function commonSimplePower (q, base, pow) {
    q.addMathFormula(base + '^\\color{blue}[' + pow + ']')
    q.answer = Math.pow(base, pow)
}


level.addQuestion({
    generator: function (q) {
        commonSimplePower(q, random.fairChoice([3, 4, 5, 6, 7, 10]), 2)
    },
    times: 2
})


// //FIXME
// level.addQuestion({
//     generator: function (q) {
//         commonSimplePower(q, random.fairChoice([2, 3]), 3)
//     }
// })
//


// //Découvrir la notation sous forme de puissance. Base "1, 3, 4, 5".
// level.addQuestion({
//     generator: function (q) {
//         let base = random.fairChoice([1, 3, 4, 5], {name: 'base'})
//         let pow = random.fairChoiceInt(1, 3, {name: 'pow'})
//         q.addMathFormula(base + '^\\color{blue}[' + pow + ']')
//         q.answer = Math.pow(base, pow)
//     },
//     times: 3
//
// })



export default level
